import { Component, Input, Output, EventEmitter } from '@angular/core';

/**
 * 多行文本框大小对象
 *
 * @export
 * @interface IAutoSizeObj
 */
export interface IAutoSizeObj {
    minRows: number; // 最小行数
    maxRows: number; // 最大行数
}

@Component({
    selector: 'clink-customize-textarea',
    templateUrl: './customize-textarea.component.html',
    styleUrls: ['./customize-textarea.component.less'],
})
export class CustomizeTextareaComponent {
    @Input() initialValue?: string; // 初始值
    @Input() readonly = false; // 是否只读
    @Input() disabled = false; // 是否禁用
    @Input() required = false; // 是否必填
    @Input() isError = false; // 当前对应控件是否有错误
    @Input() errorExpression = '必填项！'; // 错误提示语
    @Input() placeholderContent = ''; // 占位提示内容
    @Output() updateValue: EventEmitter<any> = new EventEmitter();

    currentAutoSize: IAutoSizeObj = {
        // 当前多行文本框自适应内容高度配置
        minRows: 1,
        maxRows: 1,
    };
    defaltAutoSize: IAutoSizeObj = {
        // 默认自适应内容高度配置
        minRows: 3,
        maxRows: 6,
    };
    singleSize: IAutoSizeObj = {
        // 初始化页面时展示单行
        minRows: 1,
        maxRows: 1,
    };
    isFirstFocus = true; // 是否为第一次聚焦

    constructor() {}

    /**
     * 根据字段聚焦状态变化高度
     */
    changeRemarkSize(): void {
        if (this.isFirstFocus) {
            this.currentAutoSize = this.defaltAutoSize;
            this.isFirstFocus = false;
        }
    }

    /**
     * 更新文本框数据
     */
    updateTextAreaValue(event: string): void {
        this.updateValue.emit(event);
    }
}
